import { formatLabel } from "../../helpers/decisionNarrativeHelpers";
import { SectionHeading } from "./NarrativePresentation";

export const ManagementDecisionAlternatives = ({ alternatives = [] }) => {
  if (alternatives.length === 0) return null;

  return (
    <section aria-labelledby="management-alternatives-title" className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
      <SectionHeading
        eyebrow="What else could Management consider?"
        title="Management Decision Alternatives"
        id="management-alternatives-title"
        description="Engine-evaluated planning alternatives retained for Management analysis. They are not Board approval choices."
      />
      <div className="mt-5 space-y-2">
        {alternatives.map((alternative, index) => (
          <details key={alternative?.id || index} className="rounded-lg border border-slate-200 p-3">
            <summary className="cursor-pointer font-medium text-slate-800">
              {alternative?.name || alternative?.strategy_name || formatLabel(alternative?.code) || `Alternative ${index + 1}`}
            </summary>
            {(alternative?.reason_not_selected || alternative?.rationale) && (
              <p className="mt-2 text-sm text-slate-600">{alternative.reason_not_selected || alternative.rationale}</p>
            )}
          </details>
        ))}
      </div>
    </section>
  );
};
